<script setup lang="ts">
  import { useLocale } from '@tundr/i18n';
  import { computed, inject } from 'vue';
  import { SIDEBAR_COLLAPSED_KEY } from '../../constants';
  import { useSidebarStore } from '../../store/sidebar.store';
  import { SidebarItem } from '../SidebarItem';
  import {
    navigationListClass,
    navigationListCollapsedClass,
    navigationWrapperClass,
    navigationWrapperCollapsedClass,
  } from './SidebarNav.css';
  import type { SidebarNavProps } from './SidebarNav.types';

  const props = defineProps<SidebarNavProps>();

  const { t } = useLocale('sidebar');

  const sidebarStore = useSidebarStore();

  const collapsed = inject(
    SIDEBAR_COLLAPSED_KEY,
    computed(() => sidebarStore.collapsed),
  );

  const navAriaLabel = computed(
    () => props.ariaLabel ?? t('main_navigation_aria_label'),
  );

  const navigationWrapperClasses = computed(() => [
    navigationWrapperClass,
    { [navigationWrapperCollapsedClass]: collapsed.value },
  ]);

  const navigationListClasses = computed(() => [
    navigationListClass,
    { [navigationListCollapsedClass]: collapsed.value },
  ]);
</script>

<template>
  <nav :class="navigationWrapperClasses" :aria-label="navAriaLabel">
    <ul :class="navigationListClasses">
      <template v-for="item in items" :key="item.label">
        <li v-if="!item.isHidden">
          <SidebarItem v-bind="item" />
        </li>
      </template>
    </ul>
  </nav>
</template>
